import { ANNIVERSARY_LIST_SUCCESS } from "../constants";

const initialState = {
  list: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
  case ANNIVERSARY_LIST_SUCCESS: 
    return {
      ...state,
      list: action.payload
    };
  default:
    return state;
  }
}